<template>
  <div class='lib__form__main' data-cy='contact-component'>
    <ValidationObserver ref='validator' slim>
      <div class='lib__form__main__content'>
        <header class='lib__form__main__header'>
          <h2 class='lib__h2'>
            {{ $t('prosumerDeclaration.accounting.title') }}
            <div class='lib__tooltips' @click='titleModalOpen = true'>
              <span>
                <i class='fas fa-info-circle lib__clickable-tooltips'></i>
              </span>
            </div>
          </h2>
        </header>
        <AccountingInformationComponent v-model='installationState.accounting' />
      </div>
    </ValidationObserver>

    <ModalDialog :closeable="$t('common.close')" :open.sync='titleModalOpen'>
      <h3>{{ $t('prosumerDeclaration.accounting.modal.title.title') }}</h3>
      <p v-html="$t('prosumerDeclaration.accounting.modal.title.text1')" />
      <p v-html="$t('prosumerDeclaration.accounting.modal.title.text2')" />
    </ModalDialog>
  </div>
</template>

<script lang='ts'>
import { Component } from 'vue-property-decorator'
import Step from '@/components/steps/Step'
import { State } from 'vuex-class'
import { InstallationInformation } from '@/models/prosumer-declaration/prosumer-declaration'
import RelayInformationComponent from '@/components/inputs/ProsumerDeclaration/RelayInformationComponent.vue'
import AccountingInformationComponent from '@/components/inputs/ProsumerDeclaration/AccountingInformationComponent.vue'

@Component({
  name: 'accounting-step',
  components: {
    AccountingInformationComponent,
    RelayInformationComponent
  }
})
export default class AccountingStep extends Step {
  //#region [Data]
  @State('requestId', { namespace: 'prosumerDeclaration' }) public requestId!: string
  @State('installation', { namespace: 'prosumerDeclaration/installation' })
  public installationState!: InstallationInformation

  public titleModalOpen: boolean = false
  //#endregion

  //#region [Method]
  public mounted() {
    this.setIsBack(false)
  }

  public async save(next: boolean, isValid: boolean) {
    if (next && isValid) {
      this.$appInsights.trackEvent('ProsumerDeclaration_StepAccounting_Validated', {
        Segment: 'ProsumerDeclaration',
        WebRef: this.requestId
      })
    }
  }

  //#endregion
}
</script>
